var React = require('react');

function Difficulty (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-932.607 -312.5)"},React.createElement("g",{"transform":"translate(284.607 24.5)"},[React.createElement("rect",{"width":"3","height":"7","transform":"translate(648.5 296.5)","fill":"none","stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1","key":0}),React.createElement("rect",{"width":"3.261","height":"10.761","transform":"translate(654.37 292.739)","fill":"none","stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1","key":1}),React.createElement("rect",{"width":"3","height":"15","transform":"translate(660.5 288.5)","fill":"none","stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1","key":2})])));
}

Difficulty.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = Difficulty;

Difficulty.default = Difficulty;
